import './FormTypeComboBox.css'
import { FieldRenderProps, FieldWrapper, FormClassComponent } from '@progress/kendo-react-form'
import { Label, Error, Hint } from '@progress/kendo-react-labels'
import TypeComboBox, { ITypeComboBoxRef } from 'components/ComboBox/TypeComboBox'
import React from 'react'
import { IDropDownValue } from 'types'

interface ICustomFieldRenderProps extends FieldRenderProps {
    inputPrefix?: React.ReactNode
    inputPrefixStyle?: React.CSSProperties
    inputSuffix?: React.ReactNode
    wrapperClassName?: string
    inputSuffixWrapperClass?: string
    fieldRef?: React.RefObject<ITypeComboBoxRef>
    formRef?: React.RefObject<FormClassComponent>
    formIdName?: string
    formTextName?: string
    onLoad?: (data: Array<IDropDownValue>) => void
}
const FormTypeComboBox = (fieldRenderProps: ICustomFieldRenderProps) => {
    const {
        validationMessage,
        touched,
        label,
        id,
        valid,
        disabled,
        hint,
        wrapperStyle,
        required,
        value,
        valueObject,
        inputPrefix,
        inputPrefixStyle,
        inputSuffix,
        wrapperClassName,
        inputSuffixWrapperClass,
        onChange,
        onLoad,
        fieldRef,
        formRef,
        formIdName,
        formTextName,
        ...others
    } = fieldRenderProps

    const showValidationMessage = touched && validationMessage
    const showHint: boolean = !showValidationMessage && hint
    const hintId = showHint ? `${id}_hint` : ''
    const errorId = showValidationMessage ? `${id}_error` : ''
    const labelId = label ? `${id}_label` : ''

    const localOnChange = (value: IDropDownValue) => {
        if (formRef && formRef.current) {
            if (formIdName) {
                formRef.current.valueSetter(formIdName, value && value.id ? value.id : undefined)
            }
            if (formTextName) {
                formRef.current.valueSetter(formTextName, value && value.text ? value.text : undefined)
            }
        }
        onChange({ value })
    }

    return (
        <FieldWrapper style={wrapperStyle} className={`form-type-combo-box ${wrapperClassName}`}>
            {label && <Label
                id={labelId}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
            >
                {required &&
                    <span className='text-danger'>*</span>
                }
                {label} &nbsp;
                {
                    showValidationMessage &&
                    <Error id={errorId}>{validationMessage}</Error>
                }
            </Label>
            }

            <div className='input-group d-flex'>

                {inputPrefix
                    &&
                    <div className={'input-group-prepend'} style={inputPrefixStyle}>
                        <span className='input-group-text'>
                            {inputPrefix}
                        </span>
                    </div>
                }

                <TypeComboBox
                    ref={fieldRef}
                    ariaLabelledBy={labelId}
                    ariaDescribedBy={`${hintId} ${errorId}`}
                    valid={valid}
                    id={id}
                    disabled={disabled}
                    value={value?.text}
                    onChange={localOnChange}
                    onLoad={onLoad}
                    wrapperStyle={{ flexGrow: 1 }}
                    style={{
                        borderTopLeftRadius: inputPrefix ? 0 : undefined,
                        borderBottomLeftRadius: inputPrefix ? 0 : undefined,
                        borderTopRightRadius: inputSuffix ? 0 : undefined,
                        borderBottomRightRadius: inputSuffix ? 0 : undefined
                    }}
                    {...others}
                />

                {inputSuffix
                    &&
                    <div className={`input-group-append ${inputSuffixWrapperClass}`}>
                        <span
                            className='input-group-text'
                            id='basic-addon2'>
                            {inputSuffix}
                        </span>
                    </div>
                }
            </div>

            {showHint && <Hint id={hintId}>{hint}</Hint>}
        </FieldWrapper >
    )
}

export default FormTypeComboBox